import { ApiMethods } from "../models/ApiMethods";
import { ApiEndpoints } from "../models/ApiEndpoints";
import {
  ApiMutateHook,
  ApiGetHook,
  useApiMutate,
  useApiGet,
} from "@skanska/vsa-client-auth";
import {
  ReindexJobStartResponse,
  JobStatusResponse,
  JobDetails,
  JobHistoryItem,
} from "../models/Job";

export function useReindexAll(): ApiMutateHook<ReindexJobStartResponse, void> {
  return useApiMutate<ReindexJobStartResponse, void>(
    ApiEndpoints.ReindexAll,
    ApiMethods.Delete,
    null,
    null,
    ["reindex-job-history", "reindex-job-status"]
  );
}

export function useGetReindexJobStatus(): ApiGetHook<JobStatusResponse> {
  return useApiGet<JobStatusResponse>(
    ApiEndpoints.ReindexJobStatus,
    null,
    "reindex-job-status"
  );
}

export function useGetReindexJobHistory(): ApiGetHook<JobHistoryItem[]> {
  return useApiGet<JobHistoryItem[]>(
    `${ApiEndpoints.ReindexJobHistory}?jobType=ReindexAll`,
    null,
    "reindex-job-history"
  );
}

export function useGetReindexJobHistoryById(
  jobId: string
): ApiGetHook<JobDetails> {
  return useApiGet<JobDetails>(
    ApiEndpoints.ReindexJobHistoryById,
    jobId,
    `reindex-job-history-${jobId}`
  );
}

export function useCancelJob(): ApiMutateHook<void, void> {
  return useApiMutate<void, void>(
    ApiEndpoints.CancelJob,
    ApiMethods.Post,
    null,
    null,
    ["reindex-job-history", "reindex-job-status"]
  );
}
